import React from "react";
import PropTypes from "prop-types";

function ToolTip(props) {
  const { title, description, className } = props;
  return (
    <div
      className={`nw-tooltip-terms ${
        description ? "" : "nwc-hide"
      } ${className}`}
    >
      <span className={`nw-tooltip-tc ${className}`}>{title}</span>
      <div className={`nw-tooltip-hover ${className}`}>{description}</div>
    </div>
  );
}

ToolTip.defaultProps = {
  title: "T&C",
  description: "",
  className: "",
};
ToolTip.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  className: PropTypes.string,
};

const getFinalComponent = component => component;

const ProjectComponent = {
  getFinalComponent,
  wrapper: ToolTip,
  component: ToolTip,
};

export default ProjectComponent;



// WEBPACK FOOTER //
// ./src/component/ToolTip/index.js